export enum MessageBoxActions {
  /**
   * @deprecated please use `MessageBoxActions.Abort` instead
   */
  ABORT = 'ABORT',
  /**
   * @deprecated please use `MessageBoxActions.Cancel` instead
   */
  CANCEL = 'CANCEL',
  /**
   * @deprecated please use `MessageBoxActions.Close` instead
   */
  CLOSE = 'CLOSE',
  /**
   * @deprecated please use `MessageBoxActions.Delete` instead
   */
  DELETE = 'DELETE',
  /**
   * @deprecated please use `MessageBoxActions.Ignore` instead
   */
  IGNORE = 'IGNORE',
  /**
   * @deprecated please use `MessageBoxActions.No` instead
   */
  NO = 'NO',
  /**
   * @deprecated please use `MessageBoxActions.Retry` instead
   */
  RETRY = 'RETRY',
  /**
   * @deprecated please use `MessageBoxActions.Yes` instead
   */
  YES = 'YES',

  Abort = 'Abort',
  Cancel = 'Cancel',
  Close = 'Close',
  Delete = 'Delete',
  Ignore = 'Ignore',
  No = 'No',
  OK = 'OK',
  Retry = 'Retry',
  Yes = 'Yes'
}
